<button mat-icon-button class="settings-button">
    <mat-icon [matTooltip]="'Settings'" (click)="openSettingsModal()"
        class="actions-mat-icons settings-button-icon">settings</mat-icon>
</button>